import * as STD                            from '@emersya/mpa-std-lib';
import { Block, InputBool }                from '@emersya/mpa-components-lib';
import CM                                  from '@emersya/mpa-components-manager-lib';
import * as BasketNS                               from '@emersya/mpa-basket-lib';
import ViewerComponent, { NS as ViewerNS } from '../../../viewer/Viewer/Viewer';
import { NS as StandingPartitionsHeadsNS } from '../StandingPartitionsHeads/StandingPartitionsHeads';
import { NS as StandingStorageNS }         from '../StandingStorage/StandingStorage';

export interface IStandingArchComponentConfiguration extends Block.Configuration {
	text : STD.translationsManager.TranslationMapping;
};

export class StandingArchComponent extends Block.Component {
	static override initialize() {
		super.initialize();
	};

	readonly plannerCategory! : ViewerComponent.ProductCategory;
	viewerNode : ViewerComponent.ProductInstance | null = null;
	archDimensions : { width : number; depth : number; height : number } | null = null;
	firstInstance : boolean = true;
	manualRemove : boolean = false;

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('');
		}
		const dpart = p.getPart([ 'dimensions' ]);
		return {
			width :  Number.parseFloat(dpart.getPart([ 'width' ])?.reference?.value || <string> <any> 1),
			depth :  Number.parseFloat(dpart.getPart([ 'depth' ])?.reference?.value || <string> <any> 1),
			height : Number.parseFloat(dpart.getPart([ 'height' ])?.reference?.value || <string> <any> 1)
		};
	};

	getWallThickness() {
		// TODO : DEHARDCODE
		return 0.05;
	}

	getBusinessArchSizeStickToStorage() {
		// TODO : DEHARDCODE
		return 0.44;
	}

	getPrestigeArchSizeStickToStorage() {
		// TODO : DEHARDCODE
		return 0.44;
	}

	private computeMatrix(side : string) {
		const wdh = this.getWDH();
		const x = wdh.width;
		const y = wdh.height;
		const z = wdh.depth;
		void y;
		const surface = x * z;
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available in arch!');
		}
		const archLeft = app.component_configuration.productsComponents.find(x => x.type ===
			'arch' &&
			x.SKU ===
			'arch-' +
			product.id +
			'-left');
		const archRight = app.component_configuration.productsComponents.find(x => x.type ===
			'arch' &&
			x.SKU ===
			'arch-' +
			product.id +
			'-right');
		const archSpecial = app.component_configuration.productsComponents.find(x => x.type ===
			'arch' &&
			x.SKU ===
			'arch-' +
			product.id +
			'-special');
		if (!archLeft || !archRight || !archSpecial) {
			throw STD.errors.user('No arch found');
		}


		const boundingBoxArchLeft = archLeft.boundingBox;
		const boundingBoxArchRight = archRight.boundingBox;
		const boundingBoxArchSpecial = archSpecial.boundingBox;
		if (!boundingBoxArchLeft || !boundingBoxArchRight || !boundingBoxArchSpecial) {
			throw STD.errors.user('Missing bounding box for an arch ');
		}
		const partitionsHeads = app.modules.used.find(x => x.id === 'standing-partitionsHeads');
		if (!partitionsHeads) {
			throw STD.errors.user('Partitions Heads not instanciate before arch');
		}
		const partitionHeadsComponent = <StandingPartitionsHeadsNS.Component> partitionsHeads.component;
		if (!partitionHeadsComponent) {
			throw STD.errors.user('Partitions Heads doesnt have component in arch');
		}
		let boundingBoxPartitions = partitionHeadsComponent.partitionsWidth;
		if (!boundingBoxPartitions) {
			boundingBoxPartitions = 0;
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available in arch');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			throw STD.errors.user('No current option in layout part in arch');
		}
		const layoutId = layoutCurrentOption.id;
		const archBusinessSizeStickToStorage = this.getBusinessArchSizeStickToStorage();
		const archPrestigeSizeStickToStorage = this.getPrestigeArchSizeStickToStorage();

		if (product.id === 'business') {
			const archSpecialSmall = app.component_configuration.productsComponents.find(x => x.type ===
				'arch' &&
				x.SKU ===
				'arch-' +
				product.id +
				'-specialSmall');
			if (!archSpecialSmall) {
				throw STD.errors.user('No special Small arch found');
			}
			const boundingBoxArchSpecialSmall = archSpecialSmall.boundingBox;
			if (!boundingBoxArchSpecialSmall) {
				throw STD.errors.user('Missing bounding box for small special business arch ');
			}
			if (surface > 35) {
				if (layoutId === 'shape-no-wall') {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
				} else if (layoutId === 'shape-back-left') {
					if (side === 'right') {
						return (ViewerNS.Component.mtx([
							-x / 2 + boundingBoxArchRight.depth + 3 - archBusinessSizeStickToStorage,
							0,
							-z / 2 + boundingBoxArchRight.width
						], [ 1, 1, 1 ], 90));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-back') {
					if (side === 'specialSmall') {
						const storage1x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage1x1Classic');
						if (!storage1x1Classic) {
							throw STD.errors.user('No storage 1x1 Classic found in arch');
						}
						const boundingBox1x1Classic = storage1x1Classic.boundingBox;
						if (!boundingBox1x1Classic) {
							throw STD.errors.user('Missing bounding box for storage in arch');
						}
						return (ViewerNS.Component.mtx([
							-x / 2 + boundingBox1x1Classic.width + boundingBoxPartitions,
							0,
							-z / 2 + boundingBoxArchSpecialSmall.depth
						], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-back-right') {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([
							x / 2 - boundingBoxArchLeft.depth - 3 + archBusinessSizeStickToStorage,
							0,
							-z / 2 + boundingBoxArchLeft.width
						], [ 1, 1, 1 ], 270));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([
							-x / 2 + boundingBoxArchLeft.width,
							0,
							-z / 2 + boundingBoxArchLeft.depth + 3 - archBusinessSizeStickToStorage
						], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else {
					throw STD.errors.user('Unknown layoutId in arch');
				}
			} else if (surface > 25) {
				if (layoutId === 'shape-no-wall') {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
				} else if (layoutId === 'shape-back-left') {
					if (side === 'right') {
						return (ViewerNS.Component.mtx([
							-x / 2 + boundingBoxArchRight.depth + 2 - archBusinessSizeStickToStorage,
							0,
							-z / 2 + boundingBoxArchRight.width
						], [ 1, 1, 1 ], 90));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-back') {
					if (side === 'specialSmall') {
						const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1Classic');
						if (!storage2x1Classic) {
							throw STD.errors.user('No storage 2x1 Classic found in arch');
						}
						const boundingBox2x1Classic = storage2x1Classic.boundingBox;
						if (!boundingBox2x1Classic) {
							throw STD.errors.user('Missing bounding box for storage in arch');
						}
						return (ViewerNS.Component.mtx([
							-x / 2 + boundingBox2x1Classic.width + boundingBoxPartitions,
							0,
							-z / 2 + boundingBoxArchSpecialSmall.depth
						], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-back-right') {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([
							x / 2 - boundingBoxArchLeft.depth - 2 + archBusinessSizeStickToStorage,
							0,
							-z / 2 + boundingBoxArchLeft.width
						], [ 1, 1, 1 ], 270));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([
							-x / 2 + boundingBoxArchLeft.width,
							0,
							-z / 2 + boundingBoxArchLeft.depth + 2 - archBusinessSizeStickToStorage
						], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else {
					throw STD.errors.user('Unknown layoutId in arch');
				}
			} else if (surface > 11) {
				if (layoutId === 'shape-no-wall') {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
				} else if (layoutId === 'shape-back-left') {
					if (side === 'right') {
						return (ViewerNS.Component.mtx([
							-x / 2 + boundingBoxArchRight.depth + 1 - archBusinessSizeStickToStorage,
							0,
							-z / 2 + boundingBoxArchRight.width
						], [ 1, 1, 1 ], 90));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-back') {
					if (side === 'specialSmall') {
						const storage1x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage1x1Classic');
						if (!storage1x1Classic) {
							throw STD.errors.user('No storage 1x1 Classic found in arch');
						}
						const boundingBox1x1Classic = storage1x1Classic.boundingBox;
						if (!boundingBox1x1Classic) {
							throw STD.errors.user('Missing bounding box for storage in arch ');
						}
						return (ViewerNS.Component.mtx([
							-x / 2 + boundingBox1x1Classic.width + boundingBoxPartitions,
							0,
							-z / 2 + boundingBoxArchSpecialSmall.depth
						], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-back-right') {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([
							x / 2 - boundingBoxArchLeft.depth - 1 + archBusinessSizeStickToStorage,
							0,
							-z / 2 + boundingBoxArchLeft.width
						], [ 1, 1, 1 ], 270));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (side === 'left') {
						return (ViewerNS.Component.mtx([
							-x / 2 + boundingBoxArchLeft.width,
							0,
							-z / 2 + boundingBoxArchLeft.depth + 1 - archBusinessSizeStickToStorage
						], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else {
					throw STD.errors.user('Unknown layoutId in arch');
				}
			} else {
				return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
			}
		} else if (product.id === 'prestige') {
			if (surface > 24) {
				if (layoutId === 'shape-no-wall') {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
				} else if (layoutId === 'shape-back-left') {
					if (side === 'right') {
						const storage3x1CornerRight = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1CornerRight');
						if (!storage3x1CornerRight) {
							throw STD.errors.user('No storage 3x1 Corner Right found in arch');
						}
						const boundingBox3x1CornerRight = storage3x1CornerRight.boundingBox;
						if (!boundingBox3x1CornerRight) {
							throw STD.errors.user('Missing bounding box for storage in arch');
						}
						return (ViewerNS.Component.mtx(
							[ -x / 2 + boundingBox3x1CornerRight.width, 0, -z / 2 + boundingBoxArchRight.depth ],
							[ 1, 1, 1 ],
							0
						));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-back') {
					if (side === 'right') {
						const storage3x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1Classic');
						if (!storage3x1Classic) {
							throw STD.errors.user('No storage 3x1 Classic found in arch');
						}
						const boundingBox3x1Classic = storage3x1Classic.boundingBox;
						if (!boundingBox3x1Classic) {
							throw STD.errors.user('Missing bounding box for storage in arch');
						}
						return (ViewerNS.Component.mtx(
							[ -x / 2 + boundingBox3x1Classic.width, 0, -z / 2 + boundingBoxArchRight.depth ],
							[ 1, 1, 1 ],
							0
						));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-back-right') {
					if (side === 'left') {
						const storage3x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage3x1CornerLeft');
						if (!storage3x1CornerLeft) {
							throw STD.errors.user('No storage 3x1 Corner Left found in arch');
						}
						const boundingBox3x1CornerLeft = storage3x1CornerLeft.boundingBox;
						if (!boundingBox3x1CornerLeft) {
							throw STD.errors.user('Missing bounding box for storage in arch');
						}
						return (ViewerNS.Component.mtx(
							[ x / 2 - boundingBox3x1CornerLeft.width, 0, -z / 2 + boundingBoxArchLeft.depth ],
							[ 1, 1, 1 ],
							0
						));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (side === 'special') {
						return (ViewerNS.Component.mtx([
							-x / 2 + boundingBoxArchSpecial.width,
							0,
							-z / 2 + 3 + boundingBoxArchSpecial.depth - archPrestigeSizeStickToStorage
						], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else {
					throw STD.errors.user('Unknown layoutId in arch');
				}
			} else if (surface > 17) {
				if (layoutId === 'shape-no-wall') {
					return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
				} else if (layoutId === 'shape-back-left') {
					if (side === 'right') {
						const storage2x1CornerRight = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1CornerRight');
						if (!storage2x1CornerRight) {
							throw STD.errors.user('No storage 2x1 Corner Right found in arch');
						}
						const boundingBox2x1CornerRight = storage2x1CornerRight.boundingBox;
						if (!boundingBox2x1CornerRight) {
							throw STD.errors.user('Missing bounding box for storage in arch');
						}
						return (ViewerNS.Component.mtx(
							[ -x / 2 + boundingBox2x1CornerRight.width, 0, -z / 2 + boundingBoxArchRight.depth ],
							[ 1, 1, 1 ],
							0
						));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-back') {
					if (side === 'right') {
						const storage2x1Classic = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1Classic');
						if (!storage2x1Classic) {
							throw STD.errors.user('No storage 2x1 Classic found in arch');
						}
						const boundingBox2x1Classic = storage2x1Classic.boundingBox;
						if (!boundingBox2x1Classic) {
							throw STD.errors.user('Missing bounding box for storage in arch');
						}
						return (ViewerNS.Component.mtx(
							[ -x / 2 + boundingBox2x1Classic.width, 0, -z / 2 + boundingBoxArchRight.depth ],
							[ 1, 1, 1 ],
							0
						));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-back-right') {
					if (side === 'left') {
						const storage2x1CornerLeft = app.component_configuration.productsComponents.find(x => x.type ===
							'storage' &&
							x.SKU ===
							'storage2x1CornerLeft');
						if (!storage2x1CornerLeft) {
							throw STD.errors.user('No storage 2x1 Corner Left found in arch');
						}
						const boundingBox2x1CornerLeft = storage2x1CornerLeft.boundingBox;
						if (!boundingBox2x1CornerLeft) {
							throw STD.errors.user('Missing bounding box for storage in arch');
						}
						return (ViewerNS.Component.mtx(
							[ x / 2 - boundingBox2x1CornerLeft.width, 0, -z / 2 + boundingBoxArchLeft.depth ],
							[ 1, 1, 1 ],
							0
						));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else if (layoutId === 'shape-left-back-right') {
					if (side === 'special') {
						return (ViewerNS.Component.mtx([
							-x / 2 + boundingBoxArchSpecial.width,
							0,
							-z / 2 + 2 + boundingBoxArchSpecial.depth - archPrestigeSizeStickToStorage
						], [ 1, 1, 1 ], 0));
					} else {
						return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
					}
				} else {
					throw STD.errors.user('Unknown layoutId in arch');
				}
			} else {
				return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
			}
		} else if (product.id === 'siae' || product.id === 'confort') {
			return (ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
		} else {
			throw STD.errors.user('Unknown product name in arch');
		}
	}

	async insert() {
		// insert nodes
		const product = app.currentProduct;
		if (this.viewerNode || !product || !app.viewer.planner) {
			this.component_throwUserError('');
		}
		const category = app.viewer.categories.find(x => x.name === 'arch');
		if (!category) {
			this.component_throwLibraryError('');
		}
		if (app.isReloading) {
			const instances = Array.from(app.viewer.safe.value.productInstances);
			const node = instances.find(x => x.product.category === category);
			if (!node) {
				return;
			}
			this.viewerNode = node;
			if(product.id === 'prestige'){
				await (<ViewerGraphicsNS.Component> this.component_find('@:graphic')).updateValue((<any> node).metadata.customImages[ 0 ]);
			}
			this.viewerNode.setName('arch');
			return;
		}
		let check = true;
		if(product.id === 'business'){
			const matrixLeft = this.computeMatrix('left');
			const matrixRight = this.computeMatrix('right');
			const matrixSpecial = this.computeMatrix('special');
			const matrixSpecialSmall = this.computeMatrix('specialSmall');
			if(!this.isEqual(matrixLeft, ViewerNS.Component.mtx([0, 0, 0], [0, 0, 0], 0))){
				const archProductSchema = this.plannerCategory.products.find(x => x.SKU === 'arch-business-left');
				if (!archProductSchema) {
					return;
				}
				this.viewerNode = await archProductSchema.instantiate({
					rootLocalId : app.viewer.globalLocalId,
					appendType : 'insert',
					basketPart : [],
					basketUseDynamicTitleBinding : true,
					metadata : {
						id : this.id
					}
				});
				this.viewerNode.setName('arch');
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  this.computeMatrix('left')
						}
					]
					]
				]);
			}else if(!this.isEqual(matrixRight, ViewerNS.Component.mtx([0, 0, 0], [0, 0, 0], 0))){
				const archProductSchema = this.plannerCategory.products.find(x => x.SKU === 'arch-business-right');
				if (!archProductSchema) {
					return;
				}
				this.viewerNode = await archProductSchema.instantiate({
					rootLocalId : app.viewer.globalLocalId,
					appendType : 'insert',
					basketPart : [],
					basketUseDynamicTitleBinding : true,
					metadata : {
						id : this.id
					}
				});
				this.viewerNode.setName('arch');
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  this.computeMatrix('right')
						}
					]
					]
				]);
			}else if(!this.isEqual(matrixSpecial, ViewerNS.Component.mtx([0, 0, 0], [0, 0, 0], 0))){
				const archProductSchema = this.plannerCategory.products.find(x => x.SKU === 'arch-business-special');
				if (!archProductSchema) {
					return;
				}
				this.viewerNode = await archProductSchema.instantiate({
					rootLocalId : app.viewer.globalLocalId,
					appendType : 'insert',
					basketPart : [],
					basketUseDynamicTitleBinding : true,
					metadata : {
						id : this.id
					}
				});
				this.viewerNode.setName('arch');
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  this.computeMatrix('special')
						}
					]
					]
				]);
			}else if(!this.isEqual(matrixSpecialSmall, ViewerNS.Component.mtx([0, 0, 0], [0, 0, 0], 0))){
				const archProductSchema = this.plannerCategory.products.find(x => x.SKU === 'arch-business-specialSmall');
				if (!archProductSchema) {
					return;
				}
				this.viewerNode = await archProductSchema.instantiate({
					rootLocalId : app.viewer.globalLocalId,
					appendType : 'insert',
					basketPart : [],
					basketUseDynamicTitleBinding : true,
					metadata : {
						id : this.id
					}
				});
				this.viewerNode.setName('arch');
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  this.computeMatrix('specialSmall')
						}
					]
					]
				]);
			}
		}else if(product.id === 'prestige'){
			const matrixLeft = this.computeMatrix('left');
			const matrixRight = this.computeMatrix('right');
			const matrixSpecial = this.computeMatrix('special');
			if(!this.isEqual(matrixLeft, ViewerNS.Component.mtx([0, 0, 0], [0, 0, 0], 0))){
				const archProductSchema = this.plannerCategory.products.find(x => x.SKU === 'arch-prestige-left');
				if (!archProductSchema) {
					return;
				}
				const personalizationPart = app.currentProduct.parts.find( x => x.id === 'personalization')?.currentOption;
				if(!personalizationPart){
					this.viewerNode = await archProductSchema.instantiate({
						rootLocalId : app.viewer.globalLocalId,
						appendType : 'insert',
						basketPart : [],
						basketUseDynamicTitleBinding : true,
						metadata : {
							id : this.id,
							customImages : [
								{
									enabled :   false,
									leftRight : 0,
									upDown :    0,
									resize :    1,
									rotate :    0,
									image :     null
								}
							]
						}
					});
				}else{
					const currentOptionPersonalization = app.component_configuration.productsOptions.find(x => x.SKU === personalizationPart.id);
					if(!currentOptionPersonalization){
						this.component_throwLibraryError('');
					}
					const config = currentOptionPersonalization.viewerGroups;
					if(!config){
						this.component_throwLibraryError('');
					}
					this.viewerNode = await archProductSchema.instantiate({
						rootLocalId : app.viewer.globalLocalId,
						appendType : 'insert',
						basketPart : [],
						basketUseDynamicTitleBinding : true,
						metadata : {
							id : this.id,
							customImages : [
								{
									enabled :   false,
									leftRight : 0,
									upDown :    0,
									resize :    1,
									rotate :    0,
									image :     null
								}
							]
						},
						configuration : {
							'arch-prestige-left' : {
								materialsGroups : config
							}
						}
					});
				}

				this.viewerNode.setName('arch');
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  this.computeMatrix('left')
						}
					]
					]
				]);
			}else if(!this.isEqual(matrixRight, ViewerNS.Component.mtx([0, 0, 0], [0, 0, 0], 0))){
				const archProductSchema = this.plannerCategory.products.find(x => x.SKU === 'arch-prestige-right');
				if (!archProductSchema) {
					return;
				}
				const personalizationPart = app.currentProduct.parts.find( x => x.id === 'personalization')?.currentOption;
				if(!personalizationPart){
					this.viewerNode = await archProductSchema.instantiate({
						rootLocalId : app.viewer.globalLocalId,
						appendType : 'insert',
						basketPart : [],
						basketUseDynamicTitleBinding : true,
						metadata : {
							id : this.id,
							customImages : [
								{
									enabled :   false,
									leftRight : 0,
									upDown :    0,
									resize :    1,
									rotate :    0,
									image :     null
								}
							]
						}
					});
				}else{
					const currentOptionPersonalization = app.component_configuration.productsOptions.find(x => x.SKU === personalizationPart.id);
					if(!currentOptionPersonalization){
						this.component_throwLibraryError('');
					}
					const config = currentOptionPersonalization.viewerGroups;
					if(!config){
						this.component_throwLibraryError('');
					}
					this.viewerNode = await archProductSchema.instantiate({
						rootLocalId : app.viewer.globalLocalId,
						appendType : 'insert',
						basketPart : [],
						basketUseDynamicTitleBinding : true,
						metadata : {
							id : this.id,
							customImages : [
								{
									enabled :   false,
									leftRight : 0,
									upDown :    0,
									resize :    1,
									rotate :    0,
									image :     null
								}
							]
						},
						configuration : {
							'arch-prestige-right' : {
								materialsGroups : config
							}
						}
					});
				}
				this.viewerNode.setName('arch');
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  this.computeMatrix('right')
						}
					]
					]
				]);
			}else if(!this.isEqual(matrixSpecial, ViewerNS.Component.mtx([0, 0, 0], [0, 0, 0], 0))){
				const archProductSchema = this.plannerCategory.products.find(x => x.SKU === 'arch-prestige-special');
				if (!archProductSchema) {
					return;
				}
				const personalizationPart = app.currentProduct.parts.find( x => x.id === 'personalization')?.currentOption;
				if(!personalizationPart){
					this.viewerNode = await archProductSchema.instantiate({
						rootLocalId : app.viewer.globalLocalId,
						appendType : 'insert',
						basketPart : [],
						basketUseDynamicTitleBinding : true,
						metadata : {
							id : this.id,
							customImages : [
								{
									enabled :   false,
									leftRight : 0,
									upDown :    0,
									resize :    1,
									rotate :    0,
									image :     null
								}
							]
						}
					});
				}else{
					const currentOptionPersonalization = app.component_configuration.productsOptions.find(x => x.SKU === personalizationPart.id);
					if(!currentOptionPersonalization){
						this.component_throwLibraryError('');
					}
					const config = currentOptionPersonalization.viewerGroups;
					if(!config){
						this.component_throwLibraryError('');
					}
					this.viewerNode = await archProductSchema.instantiate({
						rootLocalId : app.viewer.globalLocalId,
						appendType : 'insert',
						basketPart : [],
						basketUseDynamicTitleBinding : true,
						metadata : {
							id : this.id,
							customImages : [
								{
									enabled :   false,
									leftRight : 0,
									upDown :    0,
									resize :    1,
									rotate :    0,
									image :     null
								}
							]
						},
						configuration : {
							'arch-prestige-special' : {
								materialsGroups : config
							}
						}
					});
				}
				this.viewerNode.setName('arch');
				await app.viewer.batch([
					[
						'setProductNodesInstancesMatrices', [
						{
							localId : this.viewerNode.localId,
							matrix :  this.computeMatrix('special')
						}
					]
					]
				]);
			}else{
				check = false;
			}
			const ciData = this.viewerNode?.metadata?.customImages?.[ 0 ];
			if (ciData) {
				await (<ViewerGraphicsNS.Component> this.component_find('@:graphic')).updateValue(<any> ciData);
			}
		}
		const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
		if (!inputBool) {
			throw STD.errors.user('Missing input bool in content');
		}
		if(!inputBool.value && check){
			this.manualRemove = false;
			await inputBool.updateValue(true);
		}else if(!check && inputBool.value){
			this.manualRemove = true;
			await inputBool.updateValue(false);
		}
	};

	isEqual(tableau1 : ViewerComponent.TMatrix , tableau2 : ViewerComponent.TMatrix ) {
		if (tableau1.length !== tableau2.length) return false;

		return tableau1.every((value, index) => value === tableau2[index]);
	};

	updateArchDimensions(){
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available in arch!');
		}
		const archLeft = app.component_configuration.productsComponents.find(x => x.type ===
			'arch' &&
			x.SKU ===
			'arch-' +
			product.id +
			'-left');
		const archRight = app.component_configuration.productsComponents.find(x => x.type ===
			'arch' &&
			x.SKU ===
			'arch-' +
			product.id +
			'-right');
		const archSpecial = app.component_configuration.productsComponents.find(x => x.type ===
			'arch' &&
			x.SKU ===
			'arch-' +
			product.id +
			'-special');
		if (!archLeft || !archRight || !archSpecial) {
			throw STD.errors.user('No arch found');
		}


		const boundingBoxArchLeft = archLeft.boundingBox;
		const boundingBoxArchRight = archRight.boundingBox;
		const boundingBoxArchSpecial = archSpecial.boundingBox;
		if (!boundingBoxArchLeft || !boundingBoxArchRight || !boundingBoxArchSpecial) {
			throw STD.errors.user('Missing bounding box for an arch ');
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available in arch');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			throw STD.errors.user('No current option in layout part in arch');
		}
		const layoutId = layoutCurrentOption.id;
		if (product.id === 'business') {
			const archSpecialSmall = app.component_configuration.productsComponents.find(x => x.type ===
				'arch' &&
				x.SKU ===
				'arch-' +
				product.id +
				'-specialSmall');
			if (!archSpecialSmall) {
				throw STD.errors.user('No special Small arch found');
			}
			const boundingBoxArchSpecialSmall = archSpecialSmall.boundingBox;
			if (!boundingBoxArchSpecialSmall) {
				throw STD.errors.user('Missing bounding box for small special business arch ');
			}
			if (layoutId === 'shape-no-wall') {
				this.archDimensions = null;
			} else if (layoutId === 'shape-back-left') {
				this.archDimensions = boundingBoxArchRight;
			} else if (layoutId === 'shape-back') {
				this.archDimensions = boundingBoxArchSpecialSmall;
			} else if (layoutId === 'shape-back-right') {
				this.archDimensions = boundingBoxArchLeft;
			} else if (layoutId === 'shape-left-back-right') {
				this.archDimensions = boundingBoxArchLeft;
			} else {
				throw STD.errors.user('Unknown layoutId in arch');
			}
		}else if (product.id === 'prestige') {
			if (layoutId === 'shape-no-wall') {
				this.archDimensions = null;
			} else if (layoutId === 'shape-back-left') {
				this.archDimensions = boundingBoxArchRight;
			} else if (layoutId === 'shape-back') {
				this.archDimensions = boundingBoxArchRight;
			} else if (layoutId === 'shape-back-right') {
				this.archDimensions = boundingBoxArchLeft;
			} else if (layoutId === 'shape-left-back-right') {
				this.archDimensions = boundingBoxArchSpecial;
			} else {
				throw STD.errors.user('Unknown layoutId in arch');
			}
		} else if (product.id === 'siae' || product.id === 'confort') {
			this.archDimensions = null;
		} else {
			throw STD.errors.user('Unknown product name in arch');
		}
	};

	async update() {
		const product = app.currentProduct;
		if(!product){
			return;
		}
		if(product.id === 'siae' || product.id === 'confort'){
			return;
		}
		const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
		if(!inputBool){
			this.component_throwUserError('');
		}
		this.updateArchDimensions();
		if(!inputBool.value && this.firstInstance){
			await inputBool.updateValue(true);
		}else if(!inputBool.value && !this.manualRemove){
			return;
		}
		await app.viewer.freezeRendering({ keepCount : true });
		if (app.isReloading) {
			if (!this.viewerNode) {
				await this.insert();
			}
		} else {
			if (this.viewerNode) {
				await this.remove();
			}
			const wdh = this.getWDH();
			if(product.id === 'prestige'){
				if(wdh.width < 4){
					const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
					if (!inputBool) {
						throw STD.errors.user('Missing input bool in content');
					}
					if (inputBool.value) {
						await inputBool.updateValue(false);
					}
					await app.viewer.unfreezeRendering({ keepCount : true });
					return;
				}else if(wdh.depth < 4.5){
					const layoutPart = product.getPart(['layout']);
					if(!layoutPart){
						this.component_throwUserError('');
					}
					const layoutCurrentOption = layoutPart.currentOption;
					if(!layoutCurrentOption){
						this.component_throwUserError('');
					}
					if(layoutCurrentOption.id === 'shape-left-back-right'){
						const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
						if (!inputBool) {
							throw STD.errors.user('Missing input bool in content');
						}
						if (inputBool.value) {
							await inputBool.updateValue(false);
						}
						await app.viewer.unfreezeRendering({ keepCount : true });
						return;
					}
				}
			}else if(product.id === 'business'){
				const layoutPart = product.getPart(['layout']);
				if(!layoutPart){
					this.component_throwUserError('');
				}
				const layoutCurrentOption = layoutPart.currentOption;
				if(!layoutCurrentOption){
					this.component_throwUserError('');
				}
				if((wdh.width < 4.5 && layoutCurrentOption.id != 'shape-left-back-right') || wdh.width < 4){
					const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
					if (!inputBool) {
						throw STD.errors.user('Missing input bool in content');
					}
					if (inputBool.value) {
						await inputBool.updateValue(false);
					}
					await app.viewer.unfreezeRendering({ keepCount : true });
					return;
				}else if(wdh.depth < 4){
					if(layoutCurrentOption.id != 'shape-back'){
						const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
						if (!inputBool) {
							throw STD.errors.user('Missing input bool in content');
						}
						if (inputBool.value) {
							await inputBool.updateValue(false);
						}
						await app.viewer.unfreezeRendering({ keepCount : true });
						return;
					}
				}
			}
			await this.insert();
		}
		this.firstInstance = false;
		await app.viewer.unfreezeRendering({ keepCount : true });
	};

	async updateRemove() {
		// update nodes matrices
		if (!this.viewerNode) {
			return;
		}
		const product = app.currentProduct;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No current product available!');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			return;
		}
		const idMapping = this.viewerNode.idMapping;
		// this.archDimensions = { width : 0, depth : 0, height : 0 };
		const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
		if (!inputBool) {
			throw STD.errors.user('Missing input bool in content');
		}
		if (inputBool.value) {
			await inputBool.updateValue(false);
		}
		if (product.id === 'prestige') {
			if (!idMapping.leftArch || !idMapping.rightArch || !idMapping.specialArch) {
				throw STD.errors.user('Missing archs nodes');
			}
			await app.viewer.batch([
				[
					'setProductNodesInstancesMatrices', [
					{
						localId : idMapping.leftArch,
						matrix :  ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0)
					},
					{
						localId : idMapping.rightArch,
						matrix :  ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0)
					},
					{
						localId : idMapping.specialArch,
						matrix :  ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0)
					}
				]
				]
			]);
		} else {
			if (!idMapping.leftArch || !idMapping.rightArch || !idMapping.specialArch || !idMapping.specialSmallArch) {
				throw STD.errors.user('Missing archs nodes');
			}
			await app.viewer.batch([
				[
					'setProductNodesInstancesMatrices', [
					{
						localId : idMapping.leftArch,
						matrix :  ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0)
					},
					{
						localId : idMapping.rightArch,
						matrix :  ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0)
					},
					{
						localId : idMapping.specialArch,
						matrix :  ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0)
					},
					{
						localId : idMapping.specialSmallArch,
						matrix :  ViewerNS.Component.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0)
					}
				]
				]
			]);
		}

	};

	async remove() {
		if (!this.viewerNode) {
			return;
		}
		await this.viewerNode.delete();
		this.viewerNode = null;
		// this.updateBannerNodeShowCustomImageEditor();
	};

	async onProductChange_before(){
		await this.remove();
		this.firstInstance = true;
	}

	async onProductChange_after(){
		const product = app.currentProduct;
		if(!product){
			this.component_throwLibraryError('')
		}
		const productId = product.id;
		const viewerGraphic = <ViewerGraphicsNS.Component> this.component_find('@:graphic');
		await viewerGraphic.reset();
		if(productId === 'business'){
			await viewerGraphic.component_disable();
		}else if (productId === 'prestige'){
			await viewerGraphic.component_enable();
		}
	}

	async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		// await super.onValueUpdated(ev);
		if (ev.details.isDefaultValue) {
			return;
		}
		const product = app.currentProduct;
		if(!product){
			this.component_throwUserError('');
		}
		const storage = app.modules.used.find(x => x.id === 'standing-storage');
		if (!storage) {
			throw STD.errors.user('Storage not found in arch');
		}
		const graphic = this.component_find('@:graphic');
		const storageComponent = <StandingStorageNS.Component> storage.component;
		if (!storageComponent.hasStorage() && !storageComponent.isStorage) {
			const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
			if (!inputBool) {
				throw STD.errors.user('Missing input bool in content');
			}
			if (inputBool.value) {
				await inputBool.updateValue(false);
			}
			await graphic.component_disable();
			return;
		}
		const wdh = this.getWDH();
		if(product.id === 'prestige'){
			const layoutPart = product.getPart(['layout']);
			if(!layoutPart){
				this.component_throwUserError('');
			}
			const layoutCurrentOption = layoutPart.currentOption;
			if(!layoutCurrentOption){
				this.component_throwUserError('');
			}
			if(wdh.width < 4 || (wdh.depth < 4.5 && layoutCurrentOption.id === 'shape-left-back-right')){
				const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
				if (!inputBool) {
					throw STD.errors.user('Missing input bool in content');
				}
				if (inputBool.value) {
					await inputBool.updateValue(false);
					await this.remove();
				}
				await graphic.component_disable();
				return;
			}
		}else if(product.id === 'business'){
			const layoutPart = product.getPart(['layout']);
			if(!layoutPart){
				this.component_throwUserError('');
			}
			const layoutCurrentOption = layoutPart.currentOption;
			if(!layoutCurrentOption){
				this.component_throwUserError('');
			}
			if((wdh.depth < 4 && layoutCurrentOption.id != 'shape-back') || ((wdh.width < 4.5 && layoutCurrentOption.id != 'shape-left-back-right') || wdh.width < 4)){
				const inputBool = <InputBool.Component> this.component_find('@:field:content.options');
				if (!inputBool) {
					throw STD.errors.user('Missing input bool in content');
				}
				if (inputBool.value) {
					await inputBool.updateValue(false);
					await this.remove();
				}
				return;
			}
		}
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		;
		await app.transaction(async () => {
			if (ev.details.newValue) {
				//Update
				await this.update();
				if(product.id === 'prestige'){
					await graphic.component_enable();
				}
			} else {
				//Update Remove
				await this.remove();
				if(product.id === 'prestige'){
					await graphic.component_disable();
				}
			}
		});
	};

	override async component_initialize() {
		await this.component_find('@:field:content').component_instantiateOuterChild({
			type :          'input-bool',
			isSlot :        false,
			declaredSlot :  null,
			id :            'options',
			slot :          null,
			tree :          this.component_tree,
			parentNode :    null,
			configuration : <InputBool.Configuration> {
				type :            'yesno',
				defaultValue :    true,
				'@translations' : {
					checked :   {
						'en' : 'Yes',
						'fr' : 'Oui'
					},
					unchecked : {
						'en' : 'No',
						'fr' : 'Non'
					}
				}
			}
		});
		await super.component_initialize();
	};

	updateBannerNodeShowCustomImageEditor() {
		if (this.viewerNode && this.viewerNode.metadata.customImages && this.viewerNode.metadata.customImages[ 0 ]) {
			this.viewerNode.metadata.customImages[ 0 ].showEditor = false;
		}
	};

	getConfiguratorMenu() {
		return this;
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		const categoryDescriptor : ViewerComponent.ProductCategory.IDescriptor & {
			products : NonNullable<ViewerComponent.ProductCategory.IDescriptor['products']>;
		} = {
			name :        'arch',
			menuActions : {
				edit :      true,
				delete :    false,
				rotate :    false,
				duplicate : false
			},
			products :    []
		};
		const createProduct = (
			viewerComponentSKU : string,
			viewerProjectCode : string,
			localId : string
		) => {
			return {
				SKU :   `${ localId }`,
				nodes : [
					{
						SKU :                         viewerComponentSKU,
						projectCode :                 viewerProjectCode,
						localId :                     localId,
						parentLocalId :               'root',
						snappable :                   false,
						fixedPositionSetIds :         null,
						draggable :                   false,
						doNotListAsProductComponent : true,
						tracked :                     true,
						matrix :                      app.viewer.mtx(
							[ 0, 0, 0 ],
							[ 1, 1, 1 ],
							0
						)
					}
				]
			};
		};
		if (app.component_configuration.products.find(x => x.SKU === 'business')) {
			const archBusiness = app.component_configuration.productsComponents.filter(x => x.type ===
				'arch' &&
				x.products.includes('business')).reduce(
				(a, c) => {
					(<any> a)[ c.SKU.replace('arch-business-', '') ] = c;
					return a;
				},
				<Record<'right' | 'left' | 'special' | 'specialSmall', typeof app.component_configuration.productsComponents[0]>> {}
			);
			if (!archBusiness.left || !archBusiness.right || !archBusiness.special || !archBusiness.specialSmall) {
				throw STD.errors.user('Missing a business arch');
			}
			for(const [key,value] of Object.entries(archBusiness)){
				if(!value.viewerComponentSKU || !value.viewerProjectCode || !value.SKU){
					this.component_throwUserError('');
				}
				void key;
				categoryDescriptor.products.push(createProduct(value.viewerComponentSKU, value.viewerProjectCode, value.SKU))
			}
			// categoryDescriptor.products.push({
			// 	SKU :   '@arch-business',
			// 	nodes : [
			// 		app.viewer.createEmptyNodeDescriptor('global', 'root', ViewerNS.Component.mtx([0,0,0], [1,1,1], 0)),
			// 		{
			// 			SKU :                         <string> archBusiness.left.viewerComponentSKU,
			// 			projectCode :                 <string> archBusiness.left.viewerProjectCode,
			// 			localId :                     'leftArch',
			// 			parentLocalId :               'global',
			// 			snappable :                   false,
			// 			fixedPositionSetIds :         null,
			// 			draggable :                   false,
			// 			doNotListAsProductComponent : true,
			// 			matrix :                      app.viewer.mtx(
			// 				[ 0, 0, 0 ],
			// 				[ 0, 0, 0 ],
			// 				0
			// 			)
			// 		},
			// 		{
			// 			SKU :                         <string> archBusiness.right.viewerComponentSKU,
			// 			projectCode :                 <string> archBusiness.right.viewerProjectCode,
			// 			localId :                     'rightArch',
			// 			parentLocalId :               'global',
			// 			snappable :                   false,
			// 			fixedPositionSetIds :         null,
			// 			draggable :                   false,
			// 			doNotListAsProductComponent : true,
			// 			matrix :                      app.viewer.mtx(
			// 				[ 0, 0, 0 ],
			// 				[ 0, 0, 0 ],
			// 				0
			// 			)
			// 		},
			// 		{
			// 			SKU :                         <string> archBusiness.special.viewerComponentSKU,
			// 			projectCode :                 <string> archBusiness.special.viewerProjectCode,
			// 			localId :                     'specialArch',
			// 			parentLocalId :               'global',
			// 			snappable :                   false,
			// 			fixedPositionSetIds :         null,
			// 			draggable :                   false,
			// 			doNotListAsProductComponent : true,
			// 			matrix :                      app.viewer.mtx(
			// 				[ 0, 0, 0 ],
			// 				[ 0, 0, 0 ],
			// 				0
			// 			)
			// 		},
			// 		{
			// 			SKU :                         <string> archBusiness.specialSmall.viewerComponentSKU,
			// 			projectCode :                 <string> archBusiness.specialSmall.viewerProjectCode,
			// 			localId :                     'specialSmallArch',
			// 			parentLocalId :               'global',
			// 			snappable :                   false,
			// 			fixedPositionSetIds :         null,
			// 			draggable :                   false,
			// 			doNotListAsProductComponent : true,
			// 			matrix :                      app.viewer.mtx(
			// 				[ 0, 0, 0 ],
			// 				[ 0, 0, 0 ],
			// 				0
			// 			)
			// 		}
			// 	]
			// });
		}
		if (app.component_configuration.products.find(x => x.SKU === 'prestige')) {
			const archPrestige = app.component_configuration.productsComponents.filter(x => x.type ===
				'arch' &&
				x.products.includes('prestige')).reduce((a, c) => {
				(<any> a)[ c.SKU.replace('arch-prestige-', '') ] = c;
				return a;
			}, <Record<'right' | 'left' | 'special', typeof app.component_configuration.productsComponents[0]>> {});
			if (!archPrestige.left || !archPrestige.right || !archPrestige.special) {
				throw STD.errors.user('Missing a prestige arch');
			}
			for(const [key,value] of Object.entries(archPrestige)){
				if(!value.viewerComponentSKU || !value.viewerProjectCode || !value.SKU){
					this.component_throwUserError('');
				}
				let side = '';
				if(key === 'special'){
					side = 'U';
				}else{
					side = key;
				}
				app.viewer.productsExtensionById[ value.SKU ] = {
					quantity :        null,
					configuratorGet : CM.PropertyOperation.CallOperation.create({
						type :          'call',
						componentPath : this.component_getPath(),
						propertyPath :  'getConfiguratorMenu',
						parameters :    []
					}),
					...{
						customImages : [
							{
								id :       'customImg',
								title :    { en : 'Add logo', fr : 'Ajouter un logo' },
								width :    1,
								height :   2,
								mesh :     'custom_logo_voilage_'+side,
								material : {
									name : 'custom_logo_voilage',
									configuration : {
										enabled : 'custom_logo_voilage',
										disabled : 'off'
									}
								},
								getLocalId() {
									return this.localId;
								},
								pricingInfo :       {
									pricing : <BasketNS.Pricing.FinalPricing.ISerialized> {
										type :  'final',
										price : {
											exclTax : 178
										}
									},
								},
								volumeComputation : {
									boundTo :          'unit',
									roundingStrategy : 'none'
								}
							}
						],
					},
				};
				void key;
				categoryDescriptor.products.push(createProduct(value.viewerComponentSKU, value.viewerProjectCode, value.SKU))
			}
			// categoryDescriptor.products.push({
			// 	SKU :   '@arch-prestige',
			// 	nodes : [
			// 		app.viewer.createEmptyNodeDescriptor('global', 'root', 0),
			// 		{
			// 			SKU :                         <string> archPrestige.left.viewerComponentSKU,
			// 			projectCode :                 <string> archPrestige.left.viewerProjectCode,
			// 			localId :                     'leftArch',
			// 			parentLocalId :               'global',
			// 			snappable :                   false,
			// 			fixedPositionSetIds :         null,
			// 			draggable :                   false,
			// 			doNotListAsProductComponent : true,
			// 			matrix :                      app.viewer.mtx(
			// 				[ 0, 0, 0 ],
			// 				[ 0, 0, 0 ],
			// 				0
			// 			)
			// 		},
			// 		{
			// 			SKU :                         <string> archPrestige.right.viewerComponentSKU,
			// 			projectCode :                 <string> archPrestige.right.viewerProjectCode,
			// 			localId :                     'rightArch',
			// 			parentLocalId :               'global',
			// 			snappable :                   false,
			// 			fixedPositionSetIds :         null,
			// 			draggable :                   false,
			// 			doNotListAsProductComponent : true,
			// 			matrix :                      app.viewer.mtx(
			// 				[ 0, 0, 0 ],
			// 				[ 0, 0, 0 ],
			// 				0
			// 			)
			// 		},
			// 		{
			// 			SKU :                         <string> archPrestige.special.viewerComponentSKU,
			// 			projectCode :                 <string> archPrestige.special.viewerProjectCode,
			// 			localId :                     'specialArch',
			// 			parentLocalId :               'global',
			// 			snappable :                   false,
			// 			fixedPositionSetIds :         null,
			// 			draggable :                   false,
			// 			doNotListAsProductComponent : true,
			// 			matrix :                      app.viewer.mtx(
			// 				[ 0, 0, 0 ],
			// 				[ 0, 0, 0 ],
			// 				0
			// 			)
			// 		}
			// 	]
			// });
		}
		(<any> this).plannerCategory = app.viewer.createCategory(categoryDescriptor);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingArchComponentConfiguration
	)
	{
		configuration[ '@innerConfigurations' ] = {
			field : {
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							label : {
								'@translations' : {
									text : configuration.text
								}
							}
						}
					}
				}
			},
			graphic :    <Partial<ViewerGraphicsNS.Configuration>> {
				forceBackgroundColor :   null,
				'@innerConfigurations' : {
					header : {
						'@innerConfigurations' : {
							title : {
								'@translations' : {
									text : {
										'en' : 'In option logo 178€',
										'fr' : 'En option logo 178€'
									}
								}
							}
						}
					}
				}
			}
		};
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});
	};
};
export namespace NS {
	export const Component = StandingArchComponent;
	export type Component = StandingArchComponent;
	export type Configuration = IStandingArchComponentConfiguration;
}
;
import manifestXMLSource                   from './StandingArch.xml';
import './StandingArch.scss';
import { NS as ViewerGraphicsNS }        from '../../../viewer/Graphics/ViewerGraphics';

CM.declare({
	id :       'standing-arch',
	type :     StandingArchComponent,
	manifest : manifestXMLSource
});
